import React from 'react';
import "./Footer.css";
import linkedin from "../../../images/linkedin.svg";
import twitter from "../../../images/twitter.svg";
import instagram from "../../../images/instagram.svg";
import facebook from "../../../images/facebook.svg";
import appstore from "../../../images/appStore-4.png";
import googlePlay from "../../../images/googlePlay-4.png";
import logo from "../../../images/logo.svg"
import { getBrandConfig } from '../../../utils/brand';

const dateObject = new Date().getFullYear();
const baseUrl = "https://www.urbancompany.com";
const googlePlayUrl =
  "https://play.google.com/store/apps/details?id=com.urbanclap.urbanclap&referrer=af_tranid%3Dz8QNeTwByuk_r9-z0SfZmA%26pid%3DMobileWeb%26c%3Dhome_app_buttons%26af_web_id%3D5d7acab0-b2d8-4553-b869-7b742d6ffc71-p";

const getLegalName = () => {
  const brandConfig = getBrandConfig();
  return brandConfig?.names?.legal || 'Urban Company Ltd.';
};

const content =`© 2014-${dateObject} ${getLegalName()}`;

const appStoreUrl = "https://apps.apple.com/US/app/id1032480595?mt=8";
const UCInstagramUrl = "https://www.instagram.com/urbancompany/";
const UCLinkedinUrl = "https://www.linkedin.com/company/urbancompany/";
const UCFacebookUrl = "https://www.facebook.com/UrbanCompany/";
const UCTwitterUrl = "https://twitter.com/urbanclap";

const Footer = () => {
  return (
    <div className="footer">
      <div className="footer-div">
        <div className="footer-logo-box">
          <img src={logo} alt="UC Logo"/>
        </div>
        <div className="footer-outer-list-div">
          <div>
            <ul className="footer-list">
              <li className="footer-list-item-header">Company</li>
              <li className="footer-list-item">
                <a href={baseUrl + "/about"} target="_blank" rel="noopener noreferrer" rel="noreferrer">
                  About us
                </a>
              </li>
              <li className="footer-list-item">
                <a href={baseUrl + "/blog"} target="_blank" rel="noopener noreferrer" rel="noreferrer">
                  Blog
                </a>
              </li>
              <li className="footer-list-item">
                <a href={"https://careers.urbancompany.com"} target="_blank" rel="noopener noreferrer" rel="noreferrer">
                  Careers
                </a>
              </li>
              <li className="footer-list-item">
                <a
                  href={baseUrl + "/anti-discrimination-policy"}
                  target="_blank" rel="noopener noreferrer" rel="noreferrer"
                >
                  Anti Discrimination Policy
                </a>
              </li>
            </ul>
          </div>
          <div className="footer-inner-list-div">
            <ul className="footer-list">
              <li className="footer-list-item-header">For Professionals</li>
              <li className="footer-list-item">
                <a href={baseUrl + "/about"} target="_blank" rel="noopener noreferrer" rel="noreferrer">
                  Join as a Professional
                </a>
              </li>
              <li className="footer-list-item">
                <a href={baseUrl + "/about"} target="_blank" rel="noopener noreferrer" rel="noreferrer">
                  Community
                </a>
              </li>
              <li className="footer-list-item">
                <a href={baseUrl + "/about"} target="_blank" rel="noopener noreferrer" rel="noreferrer">
                  Professional Support
                </a>
              </li>
            </ul>
          </div>
          <div className="footer-inner-list-div">
            <ul className="footer-list">
              <li className="footer-list-item-header">For you</li>
              <li className="footer-list-item">
                <a href={baseUrl + "/near-me"} target="_blank" rel="noopener noreferrer" rel="noreferrer">
                  Near me
                </a>
              </li>
              <li className="footer-list-item">
                <a href={baseUrl + "/reviews"} target="_blank" rel="noopener noreferrer" rel="noreferrer">
                  Reviews
                </a>
              </li>
              <li className="footer-list-item">
                <a href={baseUrl + "/purchase-giftcards"} target="_blank" rel="noopener noreferrer" rel="noreferrer">
                  Gift Card
                </a>
              </li>
              <li className="footer-list-item">
                <a href={baseUrl + "/about"} target="_blank" rel="noopener noreferrer" rel="noreferrer">
                  Mobile Apps
                </a>
              </li>
              <li className="footer-list-item">
                <a href={baseUrl + "/privacy-policy"} target="_blank" rel="noopener noreferrer" rel="noreferrer">
                  Privacy Policy
                </a>
              </li>
              <li className="footer-list-item">
                <a href={baseUrl + "/terms"} target="_blank" rel="noopener noreferrer" rel="noreferrer">
                  Terms & Conditions
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="footer-footer-div-1">
        <div className="footer-footer-uc-link">
          <a to="/home">{content}</a>
        </div>
        <div className="media-links">
          <div className="footer-social-media">
            <a href={UCFacebookUrl} target="_blank" rel="noopener noreferrer" rel="noreferrer">
              <img src={facebook} alt="No image" />
            </a>
            <a href={UCTwitterUrl} target="_blank" rel="noopener noreferrer" rel="noreferrer">
              <img src={twitter} alt="No image" />
            </a>
            <a href={UCInstagramUrl} target="_blank" rel="noopener noreferrer" rel="noreferrer">
              <img src={instagram} alt="No image" />
            </a>
            <a href={UCLinkedinUrl} target="_blank" rel="noopener noreferrer" rel="noreferrer">
              <img src={linkedin} alt="No image" />
            </a>
          </div>
          <div className="footer-app-media-dev">
            <a href={googlePlayUrl} target="_blank" rel="noopener noreferrer" rel="noreferrer">
              <img src={googlePlay} alt="No image" />
            </a>
            <a href={appStoreUrl} target="_blank" rel="noopener noreferrer" rel="noreferrer">
              <img src={appstore} alt="No image" />
            </a>
          </div>
        </div>
        <div className="footer-social-links">Social links</div>
      </div>
    </div>
  );
};

export default Footer;
